import React from "react";

interface PromotionalBonus {
  promotionalBonus: number;
}

export const PromoApplied = ({ promotionalBonus }: PromotionalBonus) => {
  return (
    <div
      className="ch-chip code-chip ch-ba--1 ch-pt--0 ch-text--lowercase ch-text--center ch-mb--1"
      style={{ paddingTop: "4px" }}
    >
      <span data-testid="promo-successfully-applied">
        £{promotionalBonus} added
      </span>
    </div>
  );
};
